import React, { useEffect } from 'react';
import Header from './header';
import Menu from './Menu';
import './main.css';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const Main = () => {
    let location = useLocation();
    let navigate = useNavigate();
    useEffect(() => {
        if (location.pathname == '/') {
            navigate('/dashboard', { replace: true });
        }
    }, []);

    const handleToogleSideBar = () => {
        document.getElementById('sideBar').classList.toggle('hideSideBar');
        document.getElementById('main-content').classList.toggle('main-content-hide');
    }

    document.getElementsByTagName('body')[0].className = 'font-sans antialiased bg-white';

    var oldScreen = window.innerWidth, newScreen = window.innerWidth;
    window.addEventListener("resize", function () {
        oldScreen = newScreen;
        newScreen = window.innerWidth;
        if (oldScreen <= 780 && 780 > newScreen && oldScreen < newScreen) {
            document.getElementById('sideBar').classList.remove('hideSideBar');
            document.getElementById('main-content').classList.remove('main-content-hide');
        }
    });

    return (
        <div className="relative">
            <Header handleToogleSideBar={handleToogleSideBar} />
            <div className='menuOpciones'>
                <div className='opciones'>
                    <Menu />
                </div>
                <div id="main-content" className="main-content flex-grow p-3 mt-20 ">
                    <Outlet />
                </div>
            </div>

        </div>
    )
}

export default Main;